import {
  required,
  email,
  cpf,
  cnpj,
  validateNumberInt,
  validateNumberInt16,
  validateNumberTinyInt,
  validatePercentage,
  validatePercentageWithoutNegative,
  validateIntegerPositive,
  validateIntegerNegative,
  validateNegativeValue,
  validatePositiveValue,
  validatePercentageLessThan100,
  validateTextWithoutSpecialCharacters
} from '@/helpers/validations';

const rulesMixin = {
  data() {
    return {
      min: v => (v !== null && v !== undefined && v.length > 0 && v.length >= this.schema.min) || `Minimo ${this.schema.min} Caracteres!`,
      max: v => (v !== null && v !== undefined && v.length <= this.schema.max) || `Máximo ${this.schema.max} Caracteres!`,
      required,
      email,
      cpf,
      cnpj,
      validateNumberInt,
      validateNumberInt16,
      validateNumberTinyInt,
      validatePercentage,
      validatePercentageWithoutNegative,
      validateIntegerPositive,
      validateIntegerNegative,
      validateNegativeValue,
      validatePositiveValue,
      validatePercentageLessThan100,
      validateTextWithoutSpecialCharacters
    };
  },

  computed: {
    rules() {
      const _vm = this;
      const { rules } = _vm.schema;

      if (!rules) return false;

      let allRules = [];

      rules.forEach(rule => rule in _vm && allRules.push(_vm[rule]));

      return allRules;
    }
  },

  methods: {
    onBlur: function () {
      this.$emit('blur');
    },

    onChange: function () {
      this.$emit('change');
    },

    onFocus: function () {
      this.$emit('focus');
    },

    onInput: function () {
      this.$emit('input');
    }
  }
};

export default rulesMixin;
